import { ChangeEvent } from 'react';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

interface Props {
  setOptin: (value: string) => void;
  field: string;
  error: boolean;
  disabled?: boolean;
}

const OptinMapping = ({ field, setOptin, error, disabled }: Props) => {
  const handleOptinValue = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setOptin(String(value));
  };

  return (
    <div className="grid-row">
      <InputWithOverlay
        inputProps={{
          onBlur: handleOptinValue,
          defaultValue: field,
          placeholder: 'Enter a mapped value',
          disabled: disabled,
          style: { fontFamily: 'monospace' },
        }}
        status={error ? 'error' : undefined}
      />
    </div>
  );
};

export default OptinMapping;
